/** @internal */
export function deepFreeze(obj) {
    for (var _i = 0, _a = Object.getOwnPropertyNames(obj); _i < _a.length; _i++) {
        var name_1 = _a[_i];
        var prop = obj[name_1];
        if (typeof prop === 'object' && prop !== null) {
            deepFreeze(prop);
        }
    }
    Object.freeze(obj);
    return obj;
}



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/util/deepFreeze.ts
// module id = 3
// module chunks = 0 1